<div class="reward-modal">
  <div class="reward-modal__header">
    @if (pages.length > 1) {
      <div class="reward-modal__header--pager">
        @for (item of pages; track $index; let i = $index) {
          <div [class.active]="currentPageIndex >= i" class="reward-modal__header--pager-page" (click)="selectPage(i)"></div>
        }
      </div>
    }
    <button class="button button--icon reward-modal__header--close" aria-label="Close" mat-icon-button mat-dialog-close>
      <lib-icon icon="x"></lib-icon>
    </button>
  </div>

  @for (page of pages; track $index; let i = $index) {
    <div [class.d-none]="currentPageIndex !== i" class="reward-modal__body">
      <ng-container [ngTemplateOutlet]="page.template" [ngTemplateOutletContext]="{data: page.data}"></ng-container>
    </div>
  }

  <div class="reward-modal__footer">
    <div class="reward-modal__footer--buttons">
      @if (pages[currentPageIndex]?.type === 'feedback') {
        <button mat-flat-button mat-dialog-close class="button button--large button--outline button--transparent">{{feedbackSettings.cancelButtonLabel || ('COMMON.cancel' | translate)}}</button>
      }

      @if (pages[currentPageIndex]?.type === 'points') {
        <button mat-flat-button class="button button--large button--outline button--transparent" (click)="navigateInNewTab('/leaderboard')">{{'LEADERBOARD.see_leaderboard' | translate}}</button>
      }

      @if (pages[currentPageIndex]?.type === 'badge') {
        <ng-container *ngIfFeature="platformFeaturesKey.ACHIEVEMENTS; else buttonPlaceholderTemplate">
          @if (isBadgesVisible) {
            <button mat-flat-button class="button button--large button--outline button--transparent" (click)="navigateInNewTab('/my-achievements')">{{'ACHIEVEMENTS.see_badges' | translate}}</button>
          } @else {
            <ng-container *ngTemplateOutlet="buttonPlaceholderTemplate"></ng-container>
          }
        </ng-container>
      }

      @if (pages[currentPageIndex]?.type === 'certificate') {
        <button mat-flat-button class="button button--large button--outline button--transparent" (click)="downloadCertificate(pages[currentPageIndex]?.data)">
          @if (certificateLoading) {
            <mat-spinner diameter="20" [disabled]="certificateLoading"></mat-spinner>
          }
          {{'CERTIFICATE.download_certificate' | translate}}
        </button>
      }

      <button mat-flat-button class="button button--large button--primary" [disabled]="isContinueLoading" (click)="nextPage()">
        @if (isContinueLoading) {
          <mat-spinner diameter="20"></mat-spinner>
        }
        {{(pages[currentPageIndex]?.type === 'feedback' && feedbackSettings.submitButtonLabel) ? feedbackSettings.submitButtonLabel : ('COMMON.continue' | translate)}}
      </button>

      <ng-template #buttonPlaceholderTemplate>
        <div></div>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #feedbackPageTemplate>
  <div class="reward-modal__page">
    <div class="reward-modal__page--header">
      @if (feedbackSettings.banner) {
        <img [cropImage]="feedbackSettings.banner | preSignedUrl | async" alt="Reward banner">
      } @else {
        <lib-icon icon="student" [duotone]="true" [size]="100"></lib-icon>
      }
    </div>
    <div class="reward-modal__page--body">
      @if (feedbackSettings.text) {
        <div class="reward-modal__page--body-title" [innerHtml]="feedbackSettings.text | safeHtml"></div>
      } @else {
        <div class="reward-modal__page--body-title">{{'LESSON_FEEDBACK.well_done' | translate}} {{'LESSON_FEEDBACK.you_finished_this_lesson' | translate}}</div>
      }

      @if (feedbackSettings.ratingEnabled) {
        <p class="reward-modal__page--body-subtitle">{{'LESSON_FEEDBACK.give_us_your_feedback' | translate}}</p>
        <div class="reward-modal__page--star-list">
          @for (item of ratings; track item) {
            <div class="reward-modal__page--star" [class.active]="feedbackForm.get('rate').value >= item" (click)="setRating(item)">
              <lib-icon icon="star" [fill]="feedbackForm.get('rate').value >= item"></lib-icon>
            </div>
          }
        </div>
      }

      @if (feedbackSettings.fields?.length) {
        <div class="reward-modal__page--feedback">
          @if (!formVisible) {
            <button mat-flat-button class="button button--primary" (click)="showForm()">{{feedbackSettings.showFormButtonLabel}}</button>
          }

          @if (formVisible) {
            <div class="lesson-feedback-modal__feedback" [formGroup]="feedbackForm">
              @for (field of feedbackSettings.fields; track field.id) {
                <div class="reward-modal__page--feedback--field-wrapper">
                  <div class="reward-modal__page--feedback--label">{{field.displayName}}</div>

                  @switch (field.type) {
                    @case (fieldTypes.FORMATTED_TEXT) {
                      <mat-form-field class="reward-modal__page--feedback--field form-field-textarea" appearance="outline">
                        <textarea
                          class="reward-modal__page--feedback--textarea"
                          matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="1"
                          [formControlName]="field.id"
                          [placeholder]="'COMMON.type_here' | translate ">
                        </textarea>
                      </mat-form-field>
                    }
                    @default {
                      <mat-form-field class="reward-modal__page--feedback--field" appearance="outline">
                        <input matInput [formControlName]="field.id">
                      </mat-form-field>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #pointsPageTemplate let-data="data">
  <div class="reward-modal__page">
    <div class="reward-modal__page--header">
      <lib-icon icon="trophy" [duotone]="true" [size]="100"></lib-icon>
    </div>
    <div class="reward-modal__page--body">
      <div class="reward-modal__page--body-title" [innerHtml]="'LESSON_FEEDBACK.earned_leaderboard_points' | translate: {count: ('<span class=\'primary-color\'>'+ data?.points +'</span>')}"></div>
      <div class="reward-modal__page--body-subtitle">{{'LEADERBOARD.you_are_now_on_position' | translate:{position: data?.currentPosition} }}</div>
    </div>
  </div>
</ng-template>

<ng-template #badgePageTemplate let-data="data">
  <div class="reward-modal__page">
    <div class="reward-modal__page--header">
      @if (data.mediaImage) {
        <img
          [cropImage]="data.mediaImage | preSignedUrl | async"
          [additionalOptions]="{width: 150, height: 150, func: 'bound'}"
          alt="achievement">
      } @else {
        <img src="assets/images/achievement.png" alt="achievement">
      }
    </div>
    <div class="reward-modal__page--body">
      <div class="reward-modal__badge-content">
        <div class="reward-modal__badge-message">
          {{ 'COMMON.congratulations' | translate }}
          <br>
          {{ 'COMMON.you_achieved_a_new_badge' | translate }}
        </div>

        <div class="reward-modal__badge-title">{{data?.title}}</div>
      </div>

      <app-badge-coupon-code [generateCode]="true" [badge]="data"></app-badge-coupon-code>
    </div>
  </div>
</ng-template>

<ng-template #certificatePageTemplate let-data="data">
  <div class="reward-modal__page">
    <div class="reward-modal__page--header">
      <div
        class="reward-modal__page--header-certificate"
        [cropImage]="data?.certifications[0]?.mediaImage | preSignedUrl | async"
        [additionalOptions]="{width: 400}">
      </div>
      <ng-template #placeholderImageTemplate>
        <img src="assets/images/achievement.png" alt="achievement">
      </ng-template>
    </div>
    <div class="reward-modal__page--body">
      <div class="reward-modal__page--body-title" [innerHtml]="'LESSON_FEEDBACK.certificate_earned' | translate"></div>
      <div class="reward-modal__page--body-subtitle" [innerHtml]="'LESSON_FEEDBACK.certificate_received_for_completing' | translate:{certificate: ('<strong>'+ data?.certifications[0]?.title +'</string>'), content: ('<strong>'+ data?.title +'</strong>')}"></div>
    </div>
  </div>
</ng-template>
